<template>
        <el-col :span="24" class="toolbar">
            <el-pagination 
            layout="total, sizes, prev, pager, next" 
            @current-change="pageChange" 
            @size-change="sizeChange"
            :current-page.sync="page.page"
            :page-size="page.pageSize"
            :page-sizes="page.sizes||[10, 20, 50, 100]"
            :total="page.total"
            style="float:right;">
            </el-pagination>
        </el-col>
</template>
<script>
export default {
  name: "TablePaging",
  data() {
    return {
      
    };
  },
  props:["page","query"],
  methods: {
   pageChange(index) {
                this.page.page = index;
                this.query(index);
            },
            sizeChange(size) {
                this.page.pageSize = size;
                this.query(1);
            }
  },
  created() {
        this.page.pageSize = this.page.pageSize || 20;
  },
};
</script>